// Third Party Components
import Axios from "axios";
import CryptoJS from "crypto-js";
import secureLocalStorage from "react-secure-storage";

// Variables
import { ApiRoutes } from "../constants";

// Custom Functions
import { handleLogout, showToaster } from "../../utility/Utils";

export const axios = Axios.create({
  rejectUnauthorized: false, // (NOTE: this will disable client verification)
  baseURL: ApiRoutes.API_HOSTNAME,
  timeout: 1000000000,
  responseType: "json",
});
axios.interceptors.request.use(
  async (config) => {
    config.headers = {
      Accept: "application/json , */*",
      "Content-Type": "application/json",
      Authorization:
        config.url != "/v1/sendmessage"
          ? `Bearer ${JSON.parse(secureLocalStorage.getItem("auth_token"))}`
          : config.data.api_key,
    };
    const endPoint = [
      "media-upload",
      "/v1/sendmessage",
      "uploadtemplatemedia",
      "inserttemplates",
      "updatetemplates",
      "insertcustomer",
      "updatecustomers",
    ];
    if (!endPoint.includes(config.url)) {
      config.data = {
        data: CryptoJS.AES.encrypt(
          JSON.stringify(config.data),
          "my-secret-key@12"
        ).toString(),
      };
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (response) => {
    if (response?.config.url != "/v1/sendmessage") {
      var bytes = CryptoJS.AES.decrypt(response?.data.data, "my-secret-key@12");
      var decryptedData = bytes.toString(CryptoJS.enc.Utf8);
      response.data.data = JSON.parse(decryptedData);
    }
    return response?.data;
  },
  (error) => {
    if (error.response?.status === 403) {
      showToaster(0, error?.response?.data?.description);
      handleLogout();
      window.location.replace("/");
    }

    return Promise.reject(error);
  }
);

export default axios;
